jQuery(function ($) {
    $('.carrossel').slick({
        arrows: false,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 3000,
        prevArrow: '<button type="button" class="slick-prev btn btn-link fs-1 p-0 lh-1"><i class="bi bi-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next btn btn-link fs-1 p-0 lh-1"><i class="bi bi-chevron-right"></i></button>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.clientes-depoimentos').slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        infinite: true,
        autoplaySpeed: 3000,
        prevArrow: '<button type="button" class="slick-prev btn btn-link fs-1 p-0 lh-1"><i class="bi bi-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next btn btn-link fs-1 p-0 lh-1"><i class="bi bi-chevron-right"></i></button>'
    });
});